.row {
  display: grid;
  gap: 16px;

  @media screen and (width >= 769px) {
    grid-template-columns: 225px 1fr;
    gap: 0;
    border: 1px solid var(--color-border-normal);
    border-bottom: none;

    &:last-of-type {
      border-bottom: 1px solid var(--color-border-normal);
    }
  }
}

.labelCell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: var(--color-gray-50);

  @media screen and (width >= 769px) {
    padding: 20px 16px;
    border-right: 1px solid var(--color-border-normal);
  }
}

.labelText {
  font-weight: 700;
}

.badges {
  display: flex;
  flex-shrink: 0;
  gap: 4px;
}

.fieldCell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: start;
  padding: 0 8px;

  input {
    font-size: var(--font-size-md);
  }

  @media screen and (width >= 769px) {
    padding-block: 20px;
    padding-right: 20px;
    padding-left: 28px;
  }
}
